import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { CurrencyDto } from "./currency.dto";
import { CreateCurrencyDto } from "./create-currency.dto";
import { UpdateCurrencyDto } from "./update-currency.dto";
import { OptionType } from "@/types/OptionType";
import { getOptionLoader } from "@/core/common/presenters/optionLoader";

export class CurrenciesResource extends ResourceBaseService<CurrencyDto, CreateCurrencyDto, UpdateCurrencyDto> {
  protected EntityDto = CurrencyDto;
  protected CreateEntityDto = CreateCurrencyDto;
  protected UpdateEntityDto = UpdateCurrencyDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/currencies");
  }

  async optionLoader(inputValue: string): Promise<OptionType[]> {
    return getOptionLoader(inputValue, ["id", "code", "label"], [{ field: "code", order: "ASC" }], (request) =>
      this.findAll(request)
    );
  }
}
